import React from 'react'
import styled from 'styled-components'


const Number = ({ number = 0, bg = "var(--background-color-2)", handleClick = null }) => {
    return (
        <Wrap onClick={handleClick} $bg={bg}><p>{number}</p></Wrap>
    )
}


export default Number



const Wrap = styled.div`
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700; 
    font-size: 18px;
    background: ${(props) => (props.$bg)};  
    color: var(--heading-color);
  
  `








